module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('hr'), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('p', [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.alert) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.alert))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "accountManager",
      "data-backdrop": "static",
      "show": "true",
      "data-keyboard": "false",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog "
  }, [_c('div', {
    staticClass: "modal-content col-sm-offset-2 col-sm-8",
    staticStyle: {
      "padding": "0px"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body ",
    staticStyle: {
      "overflow": "hidden",
      "margin-top": "0px"
    }
  }, [_c('div', {
    staticClass: "well",
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Administrative Settings")]), _vm._v(" "), (_vm.userDataComp.Provider != 'Facebook') ? _c('button', {
    staticClass: "btn btn-block btn-default",
    on: {
      "click": function($event) {
        _vm.changePassword()
      }
    }
  }, [_vm._v("Change Password")]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Sitter') ? _c('button', {
    staticClass: "btn btn-block btn-premium",
    on: {
      "click": function($event) {
        _vm.goSubscribe()
      }
    }
  }, [_vm._v("Go Premium "), _c('i', {
    staticClass: "fa fa-paw"
  })]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Client') ? _c('button', {
    staticClass: "btn btn-block btn-success",
    on: {
      "click": function($event) {
        _vm.goSubscribe()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Subscribe")]) : _vm._e(), _vm._v(" "), (_vm.compUserRole != _vm.admin) ? _c('button', {
    staticClass: "btn btn-block btn-warning",
    on: {
      "click": function($event) {
        _vm.confirmSwitchAccount()
      }
    }
  }, [_vm._v("Switch account to Sitter or Client")]) : _vm._e(), _vm._v(" "), (_vm.compUserRole == 'Sitter') ? _c('button', {
    staticClass: "btn btn-block btn-danger",
    on: {
      "click": function($event) {
        _vm.goSuspend()
      }
    }
  }, [_vm._v("Suspend Account "), _c('i', {
    staticClass: "fa fa-warning"
  })]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.hideAccountManagementModal()
      }
    }
  }, [_vm._v("Close")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6  col-md-5 col-lg-4 col-xs-12"
  }, [_c('h4', [_vm._v("Profile Photo")]), _vm._v(" "), _c('ProfilePicUpload', {
    staticStyle: {
      "padding-left": "0px",
      "min-height": "210px"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDataComp.UserName),
      expression: "userDataComp.UserName"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.userDataComp.UserName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userDataComp, "UserName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('a', {
    staticClass: "text-success",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.verifyEmail()
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.emailStatusComp))])])])]), _vm._v(" "), _c('h4', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDataComp.FirstName),
      expression: "userDataComp.FirstName"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.userDataComp.FirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userDataComp, "FirstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDataComp.LastName),
      expression: "userDataComp.LastName"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.userDataComp.LastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userDataComp, "LastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Mobile Phone "), (_vm.compUserRole == 'Sitter') ? _c('span', {
    staticClass: "red-star",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Required to publish your profile"
    }
  }, [_vm._v("★")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon1"
    }
  }, [_vm._v(_vm._s(_vm.userDataComp.CountryCode))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userDataComp.PhoneNumber),
      expression: "userDataComp.PhoneNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "disabled": _vm.phoneNumberConfirmedComp
    },
    domProps: {
      "value": (_vm.userDataComp.PhoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.userDataComp, "PhoneNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.phoneNumberComp) ? _c('span', {
    staticClass: "input-group-addon"
  }, [_c('a', {
    staticClass: "text-success",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.verifyPhone()
      }
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.phoneStatusComp))])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-default",
    on: {
      "click": function($event) {
        _vm.showAccountManagementModal()
      }
    }
  }, [_vm._v("Optional Settings")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-success",
    on: {
      "click": function($event) {
        _vm.updateUser()
      }
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "changePassword",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content "
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "well",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('ChangePassword', {
    staticStyle: {
      "padding-left": "0px"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "verifyEmail",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content "
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "well",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('VerifyEmail', {
    staticStyle: {
      "padding-left": "0px"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "verifyPhone",
      "role": "dialog",
      "aria-labelledby": "modalLabel",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content "
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "well",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('VerifyPhone', {
    staticStyle: {
      "padding-left": "0px"
    },
    attrs: {
      "countryCode": _vm.countryDataComp.CountryCode,
      "mobileNumber": _vm.userData.PhoneNumber
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "text-center hidden-xs"
  }, [_c('i', {
    staticClass: "fa fa-vcard-o"
  }), _vm._v(" Manage your Account Info")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-center hidden-sm hidden-md hidden-lg"
  }, [_c('i', {
    staticClass: "fa fa-vcard-o"
  }), _vm._v(" Manage your Account Info")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "margin-top": "0px",
      "margin-bottom": "0px"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v(" Account Management")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_vm._v(" Change Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_vm._v(" Verify Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h4', [_vm._v(" Verify Phone Number")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20647244!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account/AccountView.vue
// module id = 615
// module chunks = 2